export default __webpack_public_path__ + "static/media/HV B2B Cat vinyl.eb461b19.jpg";